module.exports = __webpack_public_path__ + "img/ic_delete.7595fb86.svg";